import React from 'react';
import {
 ListItemButton,
 ListItemIcon,
 Icon,
 ListItemText,
 Collapse
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import NavList from './NavList';

const CollapseableNavList = ({ menuItem, level=1, onNavLinkClick }) => {
    
    const  {name, icon, items } = menuItem;
    const menuUrlsArray = items.map(({url}) => url);
    
    const  { pathname } = useLocation();
    const [open, setOpen] = React.useState( menuUrlsArray.includes(pathname) || false);

    const handleClick = (e) => {
        e.preventDefault();
        setOpen(!open);
    };
    
    return(
        <>
            <ListItemButton onClick={handleClick} sx={{ my: 0, pb: 1, pl: `${level*16}px` }}>
                <ListItemIcon sx={{minWidth: '42px'}}>
                    <Icon >{icon}</Icon>
                </ListItemIcon>
                <ListItemText
                 primary={name}
                    primaryTypographyProps={{
                        fontSize: 14,
                        lineHeight: '18px',
                        color: '#000',
                      }}
                />
                {open ? <KeyboardArrowDownIcon /> : <ChevronRightIcon />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <NavList menuItems={items} level={parseInt(level) + 1} sx={{pl: `${level*16}px`}} onNavLinkClick={onNavLinkClick} />
            </Collapse>
        </>
    );
};
 
export default CollapseableNavList;
